var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKhr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.0625,
    cy: 73.9375,
    r: 73.9375,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.0609,
    cy: 73.9363,
    r: 62.3392,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.4935 103.86C67.9154 103.86 64.8603 103.392 62.3282 102.456C59.796 101.466 57.8418 100.034 56.4657 98.1628C55.0895 96.2361 54.4014 93.9241 54.4014 91.2268C54.4014 88.5295 55.0895 86.2451 56.4657 84.3735C57.8969 82.4468 59.9336 80.9881 62.5759 79.9972C65.2732 79.0064 68.576 78.511 72.4843 78.511V86.5203C70.1173 86.5203 68.3008 86.9056 67.0347 87.6763C65.7686 88.3919 65.1356 89.5204 65.1356 91.0617C65.1356 92.603 65.7136 93.7865 66.8696 94.6122C68.0806 95.3829 69.5669 95.7682 71.3284 95.7682H74.7138L71.8238 98.9059L72.0715 72.9787H82.3102V103.86H71.4935ZM60.5116 75.2907V67.3639H91.3104V75.2907H60.5116ZM72.0715 69.7585V67.0337C72.0715 66.4832 71.9614 66.0428 71.7412 65.7125C71.521 65.3272 71.1357 64.9694 70.5852 64.6391C69.5944 63.9785 68.3558 63.2629 66.8696 62.4923C65.4383 61.7216 64.2823 61.0886 63.4016 60.5932C61.0896 59.217 59.6584 57.4004 59.1079 55.1435C58.5574 52.8315 58.7776 50.4095 59.7685 47.8773C60.8144 45.3451 62.2731 43.6662 64.1447 42.8405C66.0163 42.0148 68.6861 41.6019 72.1541 41.6019C74.411 41.6019 76.6404 41.712 78.8423 41.9322C81.0992 42.0974 83.3286 42.3451 85.5305 42.6753V51.8407C83.3286 51.5104 81.1543 51.2352 79.0074 51.015C76.8606 50.7948 74.411 50.6847 71.6586 50.6847C70.8329 50.6847 70.2549 50.7673 69.9247 50.9324C69.5944 51.0975 69.3742 51.3728 69.2641 51.7581C69.099 52.1434 69.0439 52.5012 69.099 52.8315C69.154 53.1618 69.4017 53.4646 69.8421 53.7398C70.2274 53.96 70.8329 54.3178 71.6586 54.8132C72.5394 55.2536 73.4752 55.749 74.466 56.2995C75.5119 56.85 76.4202 57.3729 77.1909 57.8683C78.8973 58.8592 80.1634 60.0427 80.9891 61.4189C81.8699 62.74 82.3102 64.6116 82.3102 67.0337V69.7585H72.0715Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKhr);
export default __webpack_public_path__ + "static/media/khr.aa9dc8fc6b4c0976d960f1dc024b0a9d.svg";
export { ForwardRef as ReactComponent };